import { patientAction } from 'src/redux/actions/constant';

const {
  RESET_VALIDATE_CSV_TEMPLATE,
  SUCCESS_VALIDATE_CSV_TEMPLATE,
  FAILURE_VALIDATE_CSV_TEMPLATE,
} = patientAction;

const intitialstate: object = {
  isValidationSuccess: false,
  response: null,
};

export const validateCSVTemplateReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_VALIDATE_CSV_TEMPLATE: {
      return {
        ...state,
        isValidationSuccess: true,
        response: action.payload,
      };
    }

    case FAILURE_VALIDATE_CSV_TEMPLATE:
      return {
        ...state,
        isValidationSuccess: false,
        response: action.payload,
      };

    case RESET_VALIDATE_CSV_TEMPLATE:
      return intitialstate;

    default:
      return state;
  }
};
